module.exports = __webpack_public_path__ + "img/feature-mobile.2d02c79c.jpg";